import { Box, Stack, Typography } from "@mui/material";
import React from "react";
import GlobalButton from "../button"; // Assuming you have a reusable button component
import { useNavigate } from "react-router-dom";

const ServiceCard = ({ cardData }) => {
  const navigate = useNavigate();
  return (
    <Box
      position="relative"
      sx={{
        overflow: "hidden",
        "&:hover .card-button": {
          bottom: "15px",
          transform: "translateY(0)",
        },
      }}
    >
      <Box position={"relative"} overflow={"hidden"}>
        <Box
          height={400}
          borderRadius={2}
          overflow={"hidden"}
          border={"1px solid #c9c7c7"}
          boxShadow={
            "rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 1px 3px 1px"
          }
        >
          <img
            src={cardData.image}
            width="100%"
            height="100%"
            alt={cardData.title}
            loading="lazy"
            style={{ objectFit: "cover" }}
          />
        </Box>

        {/* Hover Button */}
        <Box
          className="card-button"
          sx={{
            position: "absolute",
            bottom: "-50px", // Initially hidden
            left: 0,
            right: 0,
            transform: "translateY(50%)",
            transition: "bottom 0.3s ease, transform 0.3s ease",
            zIndex: 999,
            textAlign: "center",
          }}
        >
          <GlobalButton
            btnText="View All Providers"
            handleClickBtn={() => {
              let result = cardData.name.toLowerCase().replace(/\s+/g, "-");
              navigate(`/service/${cardData?._id}`, { state: cardData });
            }}
            styleProps={{
              width: 170,
              height: 45,
              backgroundColor: "text.coralRed",
              fontSize: "1rem",
            }}
          />
        </Box>
      </Box>

      <Stack textAlign="center" mt={2.5} mb={1}>
        <Typography
          variant="h6"
          fontWeight={600}
          textTransform={"capitalize"}
          noWrap
        >
          {cardData?.name}
        </Typography>
        <Typography variant="body1" color="text.gunmetal">
          {`${cardData?.workerCount} Workers`}
        </Typography>
      </Stack>
    </Box>
  );
};

export default ServiceCard;
